import React from 'react';
import { FullscreenButton } from '../../../components/Fullscreen/Fullscreen';
import { useSidebarLayoutBase } from '../contexts/SidebarLayoutBase/SidebarLayoutBaseContext';
import { classes } from '../SidebarLayoutForParticipant.st.css';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { AiChatButton } from './AiChatButton/AiChatButton';

export const TopControls: React.FC = () => {
  const { pageRef } = useSidebarLayoutBase();
  const { isMobile } = useEnvironment();

  if (isMobile) {
    return null;
  }

  return (
    <div
      data-hook="top-controls"
      className={classes.stepViewTopControlsContainer}
    >
      <div className={classes.stepViewTopControls}>
        <AiChatButton />
        <FullscreenButton pageRef={pageRef} />
      </div>
    </div>
  );
};
